import React, { FC, useState } from "react";
import { Chain, useContractReads } from "wagmi";
import { BigNumber, constants } from "ethers";
import { TokenURIsToNFTs } from 'utils/Contracts';
import { DEV_TEST_ADDRESS } from 'constants/Statics';
import { ABIs, Addresses } from "../../../constants/Addresses";
import { useWagmi } from "../../../hooks/wagmi";
import { useAppDispatch, useAppSelector } from '../../hooks';
import { selectWalletItems1155 } from '../hooks';
import { setWalletItems1155 } from '../reducer';

const Wallet1155Updater: FC = (): null => {
  const { address, chain } = useWagmi();
  const wallet = DEV_TEST_ADDRESS || address;
  const items = useAppSelector(selectWalletItems1155);
  const dispatch = useAppDispatch();
  const [tokensOf, setTokensOf] = useState<({} & readonly unknown[])[]>([])

  useContractReads({
    contracts: Object.values(Addresses[chain.id].Items1155).map(_address => ({
      address: _address,
      abi: ABIs.Items1155.Badges,
      functionName: 'tokensOf',
      args: [wallet],
    })),
    cacheTime: 600_000,
    enabled: wallet !== constants.AddressZero,
    onSuccess: (data) => {
      setTokensOf(data);
    }
  })

  useContractReads({
    contracts: Object.values(Addresses[chain.id].Items1155).map((_address, i) => ({
      address: _address,
      abi: ABIs.Items1155.Badges,
      functionName: 'batchUri',
      args: [tokensOf[i]?.[0]]
    })),
    cacheTime: 600_000,
    enabled: wallet !== constants.AddressZero && tokensOf.length > 0,
    onSuccess: (data) => {
      const allNewNfts: any = {};
      Object.entries(Addresses[chain.id].Items1155).map(([name, _address], i) => {
        const newNfts = TokenURIsToNFTs(data[i] as string[], name, wallet, 'ERC1155', (tokensOf[i][1] as BigNumber[]).map(n => n.toNumber()), _address, chain as Chain);
        if (!(Object.keys(items[name] || {}).length === Object.keys(newNfts).length)) {
          allNewNfts[name] = newNfts;
        }
      });
      if (Object.keys(allNewNfts).length > 0) {
        dispatch(setWalletItems1155(allNewNfts));
      }
    }
  })

  return null;
};

export default Wallet1155Updater;
